<template>
  <v-row no-gutters align="center">
    <v-col sm="7">
      <div class="header-text-container">
        <ColorIndicator :size="15" :color="color"/>
        <span class="header-text">{{ name }}</span>
      </div>
    </v-col>
    <v-col sm="5">
      <v-fade-transition leave-absolute>
         <span v-if="!open">
           Soil type: {{ soilType || 'Not selected yet' }}
         </span>
        <v-btn
          size="x-small"
            v-if="open"
            x-small
            color="primary"
            @click.stop="toggleDialog"
            :elevation="0"
        >
          Generate schematisation
        </v-btn>
      </v-fade-transition>
    </v-col>
  </v-row>
</template>

<script>
import ColorIndicator from '@/components/common/ColorIndicator.vue';
import {mapActions} from "vuex";

export default {
  name: "ReinforcementExpandHeader",
  components: {ColorIndicator},
  props: {
    name: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      default: false
    },
    soilType: {
      type: String,
      required: false
    },
    color: {
      type: String,
      required: true
    },
  },
  methods: {
    ...mapActions('reinforcement', {
      toggleDialog: 'toggleDialog',
    })
  }
};
</script>

<style scoped>
.header-text-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.header-text {
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  margin-left: 16px;
  margin-right: 4px;
  max-width: calc(100% - 28px);
}

</style>
